<template>
  <div id="home">
    <!-- 动态背景 -->
    <!-- <div class="banner" id="banner1" style="margin: 0 auto;">
      <div class="banner-view"></div>
      <div class="banner-btn"></div>
      <div class="banner-number"></div>
      <div class="banner-progres"></div>
    </div> -->

    <!-- <div class="banner" id="banner2" style="margin: 50px auto;">
      <div class="banner-view"></div>
      <div class="banner-btn"></div>
      <div class="banner-number"></div>
      <div class="banner-progres"></div>
    </div> -->
    <canvas id="canvas" class="canvas"></canvas>
    <div style="width:100%;height:100%;justify-content:flex-end;min-width:470px;" id="login" @keyup.13="doLogin"
      class="fCenter">
      <div style="min-width:340px;align-items:center;margin-right:8%;" class="fCol">

        <el-row type="flex" justify="center" align="middle">
          <h1 style="font-family:'楷体',serif">赢 销 AI 练</h1>
        </el-row>

        <!-- 
          v-event:click:@*login?:@login='`_confirm("确定要删除该用户吗?")`'
          v-event.*login='`_warn(a,b),_confirm("确定要全局登录吗?")`'
          v-event.*login2='`_warn(a,b,"登录2...")`'
          v-event.login='`_warn(a,b),_confirm("确定要登录吗?")`' 
        -->
        <el-input style='margin-top:35px;width:87%;' class="input-user" prefix-icon="el-icon-user-solid"
          v-model="user.userName" clearable input='getVerifyCode_data.utel=arguments[0]' placeholder="请输入登录账号"
          click.native='queryClass.finally(v=>_error(queryClass_data))'
          v-event.focus:email='` isPhone(a) || ( C.focus(), false ) `'></el-input>

        <br>

        <div v-view style='margin: 8px 0;width:87%;'
          o:click:1.el-icon-view='$("input",e).type=(E=E.target).classList.toggle("Textcolor")?"text":"password"'
          >
          <!-- o:ready:50='e._view("click:1.el-icon-view")' -->
          <el-input type="password" class="input-user" prefix-icon="el-icon-view" ref='code' placeholder="请输入登录密码"
            v-model="user.passWord" xclearable
            v-event.focus:code='` a === true && C.value !== "" || ( a && C.focus(user.passWord=""), false ) `'>
            <!-- <span slot="suffix"
              class='cPointer el-input__icon' 
              style="width: 130px;color: #806266;margin-right: 10px;font-size: 12px;" 
              v-s.color=' loading === false ? "#f56c6c" : loading ? "var(--Themecolor)" : loading === 0 ? "#e6a23c" : "#806266" '
              v-s:200.opacity=' boolean ? 0 : 1 '
              onselectstart="return false" 
              @dblclick.stop.capture='user.passWord=""'
              @click.stop.capture='ClickCode'
               >
              <i class="el-input__icon" style="width:20px;margin-right:-5px;" :class=' loading ? ( "el-icon-loading" ) : "el-icon-s-promotion" '></i>
              <span class="inBlock" v-s:34.transform='array===true?"scale(1.14)":"scale(1)"' >{{ 
                $Case( loading, { 
                  1:      "验证码已获取,请输入" + number2 + "秒",
                  true:   "正在获取验证码",
                  "":     "点我获取验证码",
                  false:     "验证码获取失败！点我重新获取",
                  0:     "验证码没收到?点我重新获取",
                } )
              }}</span>
            </span> -->
          </el-input>
        </div>

        <br>

        <div class="fCenterY" style="width:87%;">
          <el-button style="width:100%;" class="btn-login" type="primary" plain @click="doLogin" id='Globalogin'
            :loading='!!boolean' vs:300.height='H-200'
            v-event.focus:loginer='`a === true && ( E.focus(), true )`'>登录</el-button>
          <el-button style="width: 45px;font-size: 20px;color: var(--Colorfont);" icon='el-icon-close' circle
            type="primary" plain @click="boolean = false, window.$Loaded()" v-s:200.opacity+='+boolean'></el-button>
        </div>

      </div>
    </div>
    <div class="footer">
      <!-- <div style="color:white;">南京悦创企业管理咨询有限公司版权所有</div>
      <div style="width:600px;margin:0 auto; padding:20px 0;">
        <div>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011402010883" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../../static/beian.png" style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">苏公网安备 32011402010883号</p>
          </a>
        </div>
        <div>
          <a target="_blank" href="https://beian.miit.gov.cn/" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">苏ICP备20035429号-4</p>
          </a>
        </div>
      </div> -->
      <div style="color:white;">深圳市傲举企业管理顾问有限公司版权所有</div>
      <div style="width:600px;margin:0 auto; padding:20px 0;">
        <div>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502004257"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../../static/beian.png" style="float:left;" />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:white;">粤公网安备
              44030502004257号</p>
          </a>
        </div>
        <div>
          <a target="_blank" href="https://beian.miit.gov.cn/"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:white;">粤ICP备05071858号
            </p>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import myhttp from "../utils/myhttp.js";
import qs from "qs";
import api from "../utils/api.js";
import banner from "../../static/banner/banner.js";

let AllPagecache;
const W = window, $Menus = W.$Menus, R = /₯(.+)₰/;
const Parseword = (str) => {
  const info = { userAccount: '', password: '' };
  info.userAccount = unescape(str || '').replace(/₯(.+)₰/, (a, b) => {
    info.password = b[0] + b.slice(2);
    return "";
  });
  return info;
};
let Base64 = require('js-base64').Base64
export default {
  name: "login",
  data() {
    const Loginfo = Parseword(A.local('$Loginfo'));
    return {
      user: {
        userName: Loginfo.userAccount || "",
        passWord: Loginfo.password || "",
        boxHeight: "",
        boxWidth: "",
      },
      show: false,
      number: 9,
      isTeacher: false,
      isTeacher2: false,

    };
  },
  watch: {
    boolean(bool) {
      if (!bool) {
        this.preLogin && (this.preLogin.isilent = true);
        this.loading = '';
        this.$timer('codetime', null);
      };

    },
    isTeacher(bool) {
      this.loading = '';
      this.isTeacher2 = this.isTeacher;
    },
  },
  methods: {
    // look(){
    //   // var url="http://yingxiaozhushou.cn/file/pre/aaa.pdf";
    //   // var url="http://yingxiaozhushou.cn/file/pre/bbb.jpg";
    //   var url="http://yingxiaozhushou.cn/file/pre/ccc.docx";
    //   window.open('http://127.0.0.1:8012/onlinePreview?url='+encodeURIComponent(Base64.encode(url)));//base64Encode(url)
    // },
    // 动态背景配置
    initBanner() {
      var banner = new FragmentBanner({
        container: "#banner1", //选择容器 必选
        imgs: [
          "../../static/banner/a1.jpg",
          "../../static/banner/a2.jpg",
          "../../static/banner/a3.jpg",
          "../../static/banner/a4.jpg"
        ], //图片集合 必选
        size: {
          width: this.boxWidth,
          height: this.boxHeight
        }, //容器的大小 可选
        //行数与列数 可选
        grid: {
          line: 3,
          list: 4
        },
        index: 0, //图片集合的索引位置 可选
        type: 1, //切换类型 1 ， 2 可选
        boxTime: 2000, //小方块来回运动的时长 可选
        fnTime: 10000 //banner切换的时长 可选
      });

      /*
  ** 只填两个必要参数也是可以的
  */
      // var banenr2 = new FragmentBanner({
      //   container: "#banner2", //选择容器 必选
      //   imgs: [
      //     "../../static/banner/a1.png",
      //     "../../static/banner/a2.png",
      //     "../../static/banner/a3.png",
      //     "../../static/banner/a4.png",
      //     "../../static/banner/a5.png"
      //   ] //图片集合
      // });
    },

    ClickCode() {
      !this.loading ? (
        this.$trigger("v-event.focus:email", "login")
          .trigger(res => res && (this.loading = true))
          .trigger("getVerifyCode", " ", { utel: this.user.userName })
          .result(res => this._warn(res) || (this.loading = false))
          .trigger(res => {
            this.loading = 1;
            this.number2 = 60;
            this.$trigger("v-event.focus:code", "selfocus");
            (async () => {
              while (true) {
                await sleep(1000);
                if (this.loading === '') return;
                if (--this.number2 <= 0) {
                  this.loading = 0;
                  return;
                };
              };
            })();
          })
      ) : (
        this.array = true,
        sleep(100, v => this.array = false),
        this.loading === 1 && this.$trigger("v-event.focus:code", "selfocus")
      );
    },

    isPhone(check) {
      const userName = this.user.userName.trim();
      if (userName === '') check === 'login' && alertWarn.reset('手机号不能为空！请输入!', void 0, '手机号不能为空！');
      else if (check !== 'isEmpty' && !A.isPhone(userName)) check === 'login' && alertWarn.reset('手机号格式不正确！请重新输入!', '手机号格式不正确！');
      else return true;
      check !== 'nofocus' && this.$trigger('v-event.focus:email', 'nofocus');
      return false;
    },

    doLogin: async function () {
      let activedIndex;
      let { userName, passWord } = this.user;
      alertError.reset();
      userName = userName.trim();

      if (userName === '') return this.$trigger('v-event.focus:email'), alertWarn.reset('用户名不能为空！'), false;
      // if( loginType === '老师登录' && this.isPhone( 'login' ) === false ) return false;
      if (passWord === '') {
        alertWarn.reset('密码不能为空！', void 0, '密码不能为空！');
        return this.$trigger('v-event.focus:code', 'selfocus'), false;
      };

      this.boolean = true;
      const res = await (this.preLogin = this.$post($Api.login, { userAccount: userName, password: passWord }, ''));
      // await this.$post( this.loading !== "" ? 'signin' : '/user/adminSignin',{ utel: userName, verifyCode: passWord },'');

      if (this.boolean === false) return;
      // res.isuccess = true;
      if (res && res.isuccess) {

        /* 如果是老师登录 -> 隐藏禁用 除了 发布的短视频管理 以外的其他菜单权限*/
        const Userinfo = res.data.data; // App.excludeKey = App.$route.meta.from.key = '$' + Date.now();

        localStorage.setItem('$Usertoken', Userinfo.token);
        // console.error(55555555555);
        localStorage.setItem("$Userinfo", $JSON(Userinfo));
        localStorage.setItem("$Username", Userinfo && (Userinfo.userName || "?"));
        // localStorage.setItem( "$uphoto", Userinfo.uphoto );
        localStorage.setItem("$userId", Userinfo.userId);
        console.log(Userinfo);
        localStorage.setItem("$Loginfo", escape(userName[0] + '₯' + passWord[0] + '哈' + (passWord.slice(1) || '') + '₰' + userName.slice(1)))
        // console.error(App.ifExistLogin, App);
        localStorage.setItem(App.ifExistLogin, Userinfo && Userinfo.userId);

        if (Userinfo.postId == 1) { // 系统管理员 projectId

          localStorage.setItem('$projectId', '0');
          A.clearLocal('isCustomer'), $Menus.forLoop(Userinfo.roleAuthListSort);

          A.doLogin();

        } else if (Userinfo.postId == 2) {
          localStorage.setItem('$projectId', Userinfo.ownership);
          A.clearLocal('isCustomer'), $Menus.forLoop(Userinfo.roleAuthListSort);

          A.doLogin();

        } else if (Userinfo.postId) { // 需要选择项目
          A.local('isCustomer', '1'), $Menus.forLoop(true);
          this.$push('SelectProject');
        } else {
          //不允许登录
        };

        this.boolean = false, this.loading = '';
        // loginType === '老师登录'  ? this.$push(activedIndex) : App.Gohomepage(NaN);

      } else {
        // alertError('账号或密码错误！');
      };

      this.$timer('codetime', null);
      setTimeout(() => {
        this.boolean = false;
        this.loading = '';
      }, 20.1234126442);

    },

  },
  mounted() {
    // this.initBanner();
    // console.error(this);
    var canvas = document.querySelector("canvas"),
      ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    ctx.lineWidth = 0.3;
    ctx.strokeStyle = new Color(150).style;
    var mousePosition = {
      x: canvas.width - 100,
      y: canvas.height - 60
    };
    var dots = {
      nb: 250,
      distance: 100,
      d_radius: 150,
      array: []
    };
    function colorValue(min) {
      return Math.floor(Math.random() * 255 + min);
    }
    function createColorStyle(r, g, b) {
      return "rgba(" + r + "," + g + "," + b + ", 0.8)";
    }
    function mixComponents(comp1, weight1, comp2, weight2) {
      return (comp1 * weight1 + comp2 * weight2) / (weight1 + weight2);
    }
    function averageColorStyles(dot1, dot2) {
      var color1 = dot1.color,
        color2 = dot2.color;
      var r = mixComponents(color1.r, dot1.radius, color2.r, dot2.radius),
        g = mixComponents(color1.g, dot1.radius, color2.g, dot2.radius),
        b = mixComponents(color1.b, dot1.radius, color2.b, dot2.radius);
      return createColorStyle(Math.floor(r), Math.floor(g), Math.floor(b));
    }
    function Color(min) {
      min = min || 0;
      this.r = colorValue(min);
      this.g = colorValue(min);
      this.b = colorValue(min);
      this.style = createColorStyle(this.r, this.g, this.b);
    }
    function Dot() {
      this.x = Math.random() * canvas.width;
      this.y = Math.random() * canvas.height;
      this.vx = -0.5 + Math.random();
      this.vy = -0.5 + Math.random();
      this.radius = Math.random() * 2;
      this.color = new Color();
    }
    Dot.prototype = {
      draw: function () {
        ctx.beginPath();
        ctx.fillStyle = this.color.style;
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false);
        ctx.fill();
      }
    };
    function createDots() {
      for (var i = 0; i < dots.nb; i++) {
        dots.array.push(new Dot());
      }
    }
    function moveDots() {
      for (var i = 0; i < dots.nb; i++) {
        var dot = dots.array[i];
        if (dot.y < 0 || dot.y > canvas.height) {
          dot.vx = dot.vx;
          dot.vy = -dot.vy;
        } else if (dot.x < 0 || dot.x > canvas.width) {
          dot.vx = -dot.vx;
          dot.vy = dot.vy;
        }
        dot.x += dot.vx;
        dot.y += dot.vy;
      }
    }
    function connectDots() {
      for (var i = 0; i < dots.nb; i++) {
        for (var j = 0; j < dots.nb; j++) {
          var i_dot = dots.array[i];
          var j_dot = dots.array[j];
          if (
            i_dot.x - j_dot.x < dots.distance &&
            i_dot.y - j_dot.y < dots.distance &&
            i_dot.x - j_dot.x > -dots.distance &&
            i_dot.y - j_dot.y > -dots.distance
          ) {
            if (
              i_dot.x - mousePosition.x < dots.d_radius &&
              i_dot.y - mousePosition.y < dots.d_radius &&
              i_dot.x - mousePosition.x > -dots.d_radius &&
              i_dot.y - mousePosition.y > -dots.d_radius
            ) {
              ctx.beginPath();
              ctx.strokeStyle = averageColorStyles(i_dot, j_dot);
              ctx.moveTo(i_dot.x, i_dot.y);
              ctx.lineTo(j_dot.x, j_dot.y);
              ctx.stroke();
              ctx.closePath();
            }
          }
        }
      }
    }
    function drawDots() {
      for (var i = 0; i < dots.nb; i++) {
        var dot = dots.array[i];
        dot.draw();
      }
    }
    function animateDots() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      moveDots();
      connectDots();
      drawDots();
      requestAnimationFrame(animateDots);
    }
    //----------------------跟着鼠标动--------------------
    document.getElementById("home").addEventListener("mousemove", function (e) {
      mousePosition.x = e.pageX;
      mousePosition.y = e.pageY;
    });
    document.getElementById("home").addEventListener("mouseleave", function (e) {
      mousePosition.x = canvas.width / 2;
      mousePosition.y = canvas.height / 2;
    });
    //----------------------跟着鼠标动--------------------
    createDots();
    requestAnimationFrame(animateDots);
  },
  created() {
    console.log('登录初始化...');
    this.boxHeight = document.documentElement.clientHeight;
    this.boxWidth = document.documentElement.clientWidth;
    if (this.userId == "null" || this.userId == "undefined") {
      this.userId = "";
    };
  },

  activated() {
    // console.error('登录页面缓存被激活...',this.boolean);
    this.loading = '';
    this.boolean = this.boolean === false ? 0 : false;
    this.$timer('codetime', null);
    localStorage.removeItem(A.loginTypeword);
  },

  components: {}
};
</script>
<style scoped>
/* @import "../../static/banner/banner.css"; */
#home {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  color: #fff;
  /* background-image: url("../../static/images/banner_slide_04.jpg"); */
  background-size: cover;
  background-position: center;
  position: relative;
  font-size: 20px;
  font-family: "montserrat";
  background-image: linear-gradient(45deg, #2c3e50, #27ae60, #2980b9, #8e44ad);
  background-size: 400%;
  animation: bganimation 15s infinite;
}

.canvas {
  position: absolute;
  z-index: 10;
}

#login {
  position: relative;
  z-index: 1000;
}

.banner-btn {
  display: none;
}

.footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
  color: #333;
  z-index: 1000;
  font-size: 16px;
  text-align: center;
}

.footer>a {
  color: #333;
}

@keyframes bganimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.Rootpage.fullscreen.vue